import { usePayPalCardFields } from '@paypal/react-paypal-js';
import { Button } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { logConfirmPaymentSource } from '../../../util/sdkCallbacks';
import TestPanelContext from '../../IntegrationPageSection/StateManagement/TestPanelContext';
import { trackButtonClick } from '../../../lib/fpti';

const SubmitPayment = ({ isPaying, setIsPaying, billingAddress }) => {
  const { cardFieldsForm } = usePayPalCardFields();
  const { updateLogs } = useContext(TestPanelContext);

  const handleClick = async () => {
    trackButtonClick('Pay');
    if (!cardFieldsForm) {
      const childErrorMessage =
        'Unable to find any child components in the <PayPalCardFieldsProvider />';

      throw new Error(childErrorMessage);
    }
    const formState = await cardFieldsForm.getState();

    if (!formState.isFormValid) {
      return alert('The payment form is invalid');
    }
    setIsPaying(true);

    cardFieldsForm
      .submit({ billingAddress })
      .catch((error) => {
        logConfirmPaymentSource({
          updateLogs,
          errorMsg: error.message
        });
      })
      .finally(() => {
        setIsPaying(false);
      });
  };

  return (
    <Button btnState={isPaying ? 'processing' : 'initial'} onClick={handleClick}>
      Pay
    </Button>
  );
};

SubmitPayment.propTypes = {
  isPaying: PropTypes.bool.isRequired,
  setIsPaying: PropTypes.func.isRequired,
  billingAddress: PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    adminArea1: PropTypes.string,
    adminArea2: PropTypes.string,
    countryCode: PropTypes.string,
    postalCode: PropTypes.string
  }).isRequired
};

export default SubmitPayment;
